import { jwtDecode } from 'jwt-decode';

export const getJWTTokenExp = (accessToken: string): number => {
  try {
    const decoded = jwtDecode(accessToken) as any;

    return decoded.exp;
  } catch (error) {
    throw error;
  }
};
